import { render, staticRenderFns } from "./handbook.vue?vue&type=template&id=87f35ab2&scoped=true&"
import script from "./handbook.vue?vue&type=script&lang=js&"
export * from "./handbook.vue?vue&type=script&lang=js&"
import style0 from "./handbook.vue?vue&type=style&index=0&id=87f35ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f35ab2",
  null
  
)

export default component.exports